import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * ログインユーザーの基本情報を保持する型
 * ログイン後の画面表示制御や機能制限に使用される。
 */
export type LoginInfo = {
  /** ユーザーID */
  userId: string;
  /** メールアドレスが認証済みかどうか */
  is_verified_email: boolean;
};

/**
 * ログイン情報のステート
 * recoil-persistでセッションストレージに永続化されるため、リロードしても保持される。
 */
export const LoginInfoState = atom<LoginInfo>({
  key: 'LoginInfoState',
  default: {
    userId: '',
    is_verified_email: false,
  },
  effects_UNSTABLE: [persistAtom],
});

export default LoginInfoState;
